import { useId } from 'react';
import { cn } from '../../../lib/utils';
import { MatchQuizOptionIcon } from '../lib/matchQuizOptionIcons';

export type MatchQuizOptionCardProps = {
  name: string;
  optionValue: string;
  checked: boolean;
  onSelect: () => void;
  title: string;
  description: string;
  optionIndex: number;
  showLeadingIcon?: boolean;
};

export function MatchQuizOptionCard({
  name,
  optionValue,
  checked,
  onSelect,
  title,
  description,
  optionIndex,
  showLeadingIcon = false,
}: MatchQuizOptionCardProps) {
  const id = useId();
  const inputId = `${id}-input`;

  return (
    <div className='relative'>
      <input
        id={inputId}
        type='radio'
        name={name}
        value={optionValue}
        checked={checked}
        onChange={() => {
          onSelect();
        }}
        className='peer sr-only'
      />
      <label
        htmlFor={inputId}
        className={cn(
          'flex cursor-pointer gap-3 rounded-xl border bg-card p-4 shadow-sm transition-colors',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-primary-600 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background',
          checked
            ? 'border-primary-600 ring-2 ring-primary-600/30'
            : 'border-border hover:border-primary-600/40',
        )}
      >
      {showLeadingIcon ? (
        <span
          className='hidden size-10 shrink-0 items-center justify-center rounded-lg bg-accent text-foreground lg:flex'
          aria-hidden
        >
          <MatchQuizOptionIcon className='size-5' optionIndex={optionIndex} />
        </span>
      ) : null}
      <span className='min-w-0 flex-1'>
        <span className='block font-semibold text-foreground'>{title}</span>
        {description ? (
          <span className='mt-1 block text-sm leading-relaxed text-muted-foreground'>
            {description}
          </span>
        ) : null}
      </span>
        <span
          className={cn(
            'mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full border-2',
            checked
              ? 'border-primary-600 bg-primary-600'
              : 'border-primary-600/70 bg-transparent',
          )}
          aria-hidden
        >
          {checked ? (
            <span className='size-2 rounded-full bg-primary-foreground' />
          ) : null}
        </span>
      </label>
    </div>
  );
}
